import React from 'react';
import cassette1 from '../cassette1.png';
import cassette2 from '../cassette2.png';
import cassette3 from '../cassette3.png';
import cassette4 from '../cassette4.png';

const TAPES = [cassette1, cassette2, cassette3, cassette4];

// Doubled so the keyframe can translate by -50% and loop seamlessly —
// at -50% the second set occupies the same screen positions as the first
// did at 0%, so there's no visible reset when the animation restarts.
const STRIP = [...TAPES, ...TAPES, ...TAPES, ...TAPES, ...TAPES, ...TAPES];

function LoginBackground() {
    return (
        <div className="login-background" aria-hidden="true">
            <div className="login-cassette-strip">
                {STRIP.map((src, i) => (
                    <img
                        key={i}
                        src={src}
                        alt=""
                        className="login-cassette"
                        decoding="async"
                        loading="eager"
                        draggable="false"
                    />
                ))}
            </div>
            <div className="login-background-vignette" />
        </div>
    );
}

export default LoginBackground;
